export default __webpack_public_path__ + "static/media/subtract-dialog.1d6c594d.png";